export enum VtmnPlayIconTypeEnum {
  Accessibility = 'accessibility',
  AddCircle = 'add-circle',
  Add = 'add',
  AlignBottom = 'align-bottom',
  AlignTop = 'align-top',
  AlignVertically = 'align-vertically',
  AlignCenter = 'alignement-center',
  AlignementLeft = 'alignement-left',
  AlignementRight = 'alignement-right',
  ArrowBackward = 'arrow-backward',
  ArrowBackwardCircle = 'arrow-backward-circle',
  ArrowDown = 'arrow-down',
  ArrowDownCircle = 'arrow-down-circle',
  ArrowExpandHor = 'arrow-expand-hor',
  ArrowForward = 'arrow-forward',
  ArrowForwardCircle = 'arrow-forward-circle',
  ArrowLeftCircle = 'arrow-left-circle',
  ArrowLeftDown = 'arrow-left-down',
  ArrowLeftRight = 'arrow-left-right',
  ArrowLeftUp = 'arrow-left-up',
  ArrowLeft = 'arrow-left',
  ArrowRightCircle = 'arrow-right-circle',
  ArrowRightDown = 'arrow-right-down',
  ArrowRightUp = 'arrow-right-up',
  ArrowRight = 'arrow-right',
  ArrowUpCircle = 'arrow-up-circle',
  ArrowUpDown = 'arrow-up-down',
  ArrowUp = 'arrow-up',
  ArrowUturnBackward = 'arrow-uturn-backward',
  ArrowUturnForward = 'arrow-uturn-forward',
  ArrowUturnLeft = 'arrow-uturn-left',
  ArrowUturnRight = 'arrow-uturn-right',
  Attachment = 'attachement',
  Award = 'award',
  Balance = 'balance',
  BankCard = 'bank-card',
  BarChart = 'bar-chart',
  BarCodeScan = 'barcode-scan',
  BezierCurve = 'bezier-curve',
  Bill = 'bill',
  BodyScan = 'body-scan',
  Bold = 'bold',
  CalendarCheck = 'calendar-check',
  CalendarDate = 'calendar-date',
  Calendar = 'calendar',
  Camera = 'camera',
  Car = 'car',
  CheckCircle = 'check-circle',
  Check = 'check',
  CheckboxMultiple = 'checkbox-multiple',
  ChevronBackward = 'chevron-backward',
  ChevronDown = 'chevron-down',
  ChevronForward = 'chevron-forward',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  CircularityBuyBack = 'circularity-buy-back',
  CircularityMaintainRepair = 'circularity-maintain-repair',
  CircularitySecondLife = 'circularity-second-life',
  CircularityShopRental = 'circularity-shop-rental',
  ClickCollect = 'click-collect',
  CloseCircle = 'close-circle',
  Close = 'close',
  CloudWindy = 'cloud-windy',
  Cloud = 'cloud',
  CodeBrackets = 'code-brackets',
  CounterHigh = 'counter-high',
  CounterLow = 'counter-low',
  CreditCard = 'credit-card',
  CustomerService = 'customer-service',
  Customize = 'customize',
  Database = 'database',
  DeleteBin = 'delete-bin',
  Devices = 'devices',
  Direction = 'direction',
  Download = 'download',
  Drizzle = 'drizzle',
  Earth = 'earth',
  Edit = 'edit',
  EmotionHappy = 'emotion-happy',
  EmotionLaugh = 'emotion-laugh',
  EmotionNeutral = 'emotion-neutral',
  EmotionSad = 'emotion-sad',
  EmotionUnhappy = 'emotion-unhappy',
  Equalizer = 'equalizer',
  Error = 'error',
  Exchange = 'exchange',
  ExitFullscreen = 'exit-fullscreen',
  Expand = 'expand',
  Experiment = 'experiment',
  ExternalLink = 'external-link',
  EyeClosed = 'eye-closed',
  EyeOff = 'eye-off',
  Eye = 'eye',
  FastDelivery = 'fast-delivery',
  Feedback = 'feedback',
  File = 'file',
  Film = 'film',
  Filter = 'filter',
  FilterOff = 'filter-off',
  Fire = 'fire',
  Flashlight = 'flashlight',
  Focus = 'focus',
  Foggy = 'foggy',
  FontSize = 'font-size',
  Football = 'football',
  Forbid = 'forbid',
  Fullscreen = 'fullscreen',
  FunctionRows = 'function-rows',
  FunctionTitles = 'function-tiles',
  Funding = 'funding',
  Gift = 'gift',
  GiftCards = 'giftcards',
  Grid = 'grid',
  Group = 'group',
  Hail = 'hail',
  HearingImpairment = 'hearing-impairment',
  HeartFilled = 'heart-filled',
  HeartPulse = 'heart-pulse',
  Heart = 'heart',
  History = 'history',
  Home = 'home',
  Hourglass = 'hourglass',
  Image = 'image',
  Information = 'information',
  Italic = 'italic',
  Keyboard = 'keyboard',
  Leaf = 'leaf',
  Lightbulb = 'lightbulb',
  Lightning = 'lightning',
  LineChart = 'line-chart',
  Link = 'link',
  ListCheck = 'list-check',
  ListSettings = 'list-settings',
  Lock = 'lock',
  Logout = 'logout',
  LoyaltyCard = 'loyalty-card',
  Mac = 'mac',
  Macbook = 'macbook',
  MailSend = 'mail-send',
  Mail = 'mail',
  MaintainRepair = 'maintain-repair',
  MapPin = 'map-pin',
  Mastercard = 'mastercard',
  Maximize = 'maximize',
  Menu = 'menu',
  Message = 'message',
  MicOff = 'mic-off',
  Mic = 'mic',
  Mist = 'mist',
  MoneyCnyBox = 'money-cny-box',
  MoneyDollarBox = 'money-dollar-box',
  MoneyEuroBox = 'money-euro-box',
  MoneyPoundBox = 'money-pound-box',
  MoonCloudy = 'moon-cloudy',
  Moon = 'moon',
  More2 = 'more-2',
  More = 'more',
  Music1 = 'music-1',
  Music2 = 'music-2',
  Navigation = 'navigation',
  Notification = 'notification',
  OrderTracking = 'order-tracking',
  ParcelLockers = 'parcel-lockers',
  PauseCircle = 'pause-circle',
  PauseFilled = 'pause-filled',
  Pause = 'pause',
  Phone = 'phone',
  PickUpPackstation = 'pick-up-packstation',
  PickUpStore = 'pick-up-store',
  PictureInPicture = 'picture-in-picture',
  PieChart = 'pie-chart',
  PlayCircle = 'play-circle',
  PlayFilled = 'play-filled',
  Play = 'play',
  Power = 'power',
  PriceTag = 'price-tag',
  Printer = 'printer',
  QrCode = 'qr-code',
  QrScan = 'qr-scan',
  Question = 'question',
  Rainy = 'rainy',
  Recycle = 'recycle',
  Refresh = 'refresh',
  Refund = 'refund',
  Rent = 'rent',
  Repair = 'repair',
  Repeat = 'repeat',
  Return = 'return',
  Riding = 'riding',
  Ruler = 'ruler',
  Rocket = 'rocket',
  Rss = 'rss',
  Run = 'run',
  Search = 'search',
  SecondUse = 'second-use',
  SecurePayment = 'secure-payment',
  Seed1 = 'seed-1',
  Seed2 = 'seed-2',
  Seed3 = 'seed-3',
  SendPlaneTop = 'send-plane-top',
  SendPlane = 'send-plane',
  Settings = 'settings',
  ShareAndroid = 'share-android',
  ShareApple = 'share-apple',
  ShieldCheck = 'shield-check',
  ShoppingAddToBag = 'shopping-add-to-bag',
  ShoppingBag = 'shopping-bag',
  ShoppingCart = 'shopping-cart',
  Shower = 'shower',
  Smartphone = 'smartphone',
  Snowy = 'snowy',
  Sparkles = 'sparkles',
  StarFilled = 'star-filled',
  StarHalfFilled = 'star-half-filled',
  Star = 'star',
  StopCircle = 'stop-circle',
  StopFilled = 'stop-filled',
  Stop = 'stop',
  Store = 'store',
  SubTract = 'subtract',
  SuitcaseStickers = 'suitcase-stickers',
  SuitcaseWork = 'suitcase-work',
  SunCloudy = 'sun-cloudy',
  Sun = 'sun',
  TshirtNumber = 't-shirt-number',
  Tshirt = 't-shirt',
  Tablet = 'tablet',
  Tactics = 'tactics',
  Task = 'task',
  TempCold = 'temp-cold',
  TempHot = 'temp-hot',
  TextCurved = 'text-curved',
  Text = 'text',
  ThumbDown = 'thumb-down',
  ThumbUp = 'thumb-up',
  Thunderstorms = 'thunderstorms',
  Time = 'time',
  Timer = 'timer',
  Tools = 'tools',
  Train = 'train',
  Trophy = 'trophy',
  Truck = 'truck',
  Unlink = 'unlink',
  Upload = 'upload',
  User = 'user',
  Vector = 'vector',
  Video = 'video',
  VolumeAlert = 'volume-alert',
  VolumeDown = 'volume-down',
  VolumeMute = 'volume-mute',
  VolumeUp = 'volume-up',
  Walk = 'walk',
  Wallet = 'wallet',
  WarningError = 'warning-error',
  WifiOff = 'wifi-off',
  WifiOn = 'wifi-on',
  Windy = 'windy',
  ZoomIn = 'zoom-in',
  ZoomOut = 'zoom-out',
}
